import { useRef } from 'react';

const useWebSocket = (onMessage) => {
  const socketRef = useRef(null);

  if (!socketRef.current) {
    const socketUrl = process.env.WS_DOMAIN
    socketRef.current = new WebSocket(socketUrl);

    socketRef.current.onopen = () => {
      console.log('WebSocket connection established');
    };

    socketRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        // console.log('WebSocket received a message:', data);
        // if (data.message.UID == "5478A25F") {
        //   console.log("received update: ", data);
        // }
        if (onMessage) {
          onMessage(data);
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    };

    socketRef.current.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    socketRef.current.onclose = () => {
      console.log('WebSocket connection closed');
      socketRef.current = null;
    };
  }

  return socketRef.current;
};

export default useWebSocket;
